import { render, staticRenderFns } from "./red-challenge.vue?vue&type=template&id=0b285385&scoped=true&"
import script from "./red-challenge.vue?vue&type=script&lang=js&"
export * from "./red-challenge.vue?vue&type=script&lang=js&"
import style0 from "./red-challenge.vue?vue&type=style&index=0&id=0b285385&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b285385",
  null
  
)

export default component.exports